import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const permisosSlice = createSlice({
  name: 'permisos',
  initialState: {
    data: []
  },
  reducers: {
    setPermisos: (state, { payload }) => {
      state.data = payload;
    }
  }
});

export const { setPermisos } = permisosSlice.actions;

export const getPermisos = () => async dispatch => {
  const { data } = await axios.get(
    `${process.env.REACT_APP_SERVER}/permissions`
  );

  dispatch(setPermisos(data));
};

export default permisosSlice.reducer;
